<template>
  <div class="card card-chat-booking float-left ml-3">
    <div class="card-body">
      <div class="mb-3">
        <b>{{ message.text }}</b>
      </div>
      <div>
        <div class="mb-4">
          {{ $t('message.bank_transfer.confirm_promptpay') }}
          <div>
            <strong>{{ expireDateTime }}</strong>
          </div>
        </div>
        <div class="mb-4">
          <h3>ยอดที่ต้องชำระ: <span class="text-orange"> {{ totalPrice | currency }} </span></h3>
        </div>
      </div>
      <hr>
      <div class="text-center" v-if="paymentSuccess">
        <i class="fas fa-check-circle -status-accepted"></i>
        {{ $t('message.success') }}
      </div>
      <div v-else>
        <qr-code-payment ref="qrCodePayment" @checkQrPayment="checkQrPayment"/>
        <hr>
        <div class="text-remark">
          {{ $t('message.promptpay.payment_remark') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { checkoutCostMixin } from '../../../mixins/checkoutCostMixin'
  import QrCodePayment from '../../qrPayment/QrCodePayment'
  import moment from 'moment-timezone'
  import axios from 'axios'

  export default {
    mixins: [checkoutCostMixin],
    props: {
      message: Object
    },
    components: {
      QrCodePayment
    },
    data () {
      return {
        expireDateTime: moment().add(1, 'hours').format('DD MMM YYYY (HH:mm)'),
        qrResponse: null,
        paymentSuccess: false
      }
    },
    computed: {
      ...mapGetters({
        appliedPromoCode: 'promoCode/getAppliedPromoCode'
      }),
      ...mapState('chatBooking', ['bookingData'])
    },
    methods: {
      checkQrPayment (response) {
        this.qrResponse = response
        // Clear old interval before starting a new one
        if (this.checkingQrPayment !== null) {
          clearInterval(this.checkingQrPayment)
          this.checkingQrPayment = null
        }
        this.checkingQrPayment = setInterval(() => {
          const url = '/qr-payments'
          axios.get(url, {params: {transaction_code: this.qrResponse.partnerTxnUid}})
            .then(res => {
              const response = res.data
              if (!response.error && response.qr_payment && response.qr_payment.status_code) {
                if (response.qr_payment.status_code === '00') {
                  clearInterval(this.checkingQrPayment)
                  this.paymentSuccess = true
                  // Send auto reply message to user
                  const message = {
                    sender_type: 'user',
                    type: 'text',
                    label: 'success-promptpay',
                    text: 'ยืนยันการชำระเงินด้วยพร้อมเพย์'
                  }
                  this.$store.commit('chatBooking/ADD_MESSAGE', message)
                } else if (response.qr_payment.status_code === '10') {
                  clearInterval(this.checkingQrPayment)
                  const alertMessage = `Error: ${response.qr_payment.error_description}`
                  this.$swal({text: alertMessage, type: 'error'})
                  // if error set qr code timeout to be expired
                  this.$refs.qrCodePayment.finishTimer()
                }
              }
            })
            .catch(error => {
              console.log('error', error)
            })
        }, 7000)
      }
    },
    beforeDestroy () {
      clearInterval(this.checkingQrPayment)
    },
    updated () {
      if (this.bookingData) {
        const qrPaymentData = {
          paymentFor: 'normal',
          chatBookingId: this.bookingData.id,
          amount: this.totalPrice
        }
        this.$refs.qrCodePayment.loadQrCode(qrPaymentData)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/chatBooking/components/PromptpayMessage.vue